"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** The injection token used to specify the virtual scrolling strategy. */
var core_1 = require("@angular/core");
exports.VIRTUAL_SCROLL_STRATEGY = new core_1.InjectionToken('VIRTUAL_SCROLL_STRATEGY');
//# sourceMappingURL=virtual-scroll-strategy.js.map